import React, { Component } from 'react';
import { Badge } from 'antd';
import { connect } from 'dva';
import moment from 'moment';
import { GetQueryString } from '../../../../utils/utils';
import Container from '../../../../components/Container';
import ListPage from '../../../../components/ListPage';
import styles from './index.less';

const { ListTable } = ListPage;
const statusColor = {
  '-1': 'yellow',
  '0': 'gray',
  '1': '#1785EC',
  '2': '#52C41A',
  '3': 'red',
};

const statusText = {
  '-1': '草稿',
  '0': '待推送',
  '1': '推送中',
  '2': '已推送',
  '3': '已终止',
};

@connect(({ pushAnalyze }) => ({
  ...pushAnalyze,
}))
class PushAnalyze extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [],
    };
  }

  componentDidMount() {
    this.setColumns();
    this.fetchList(1, 10);
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'pushAnalyze/reset',
    });
  }

  fetchList = (page, pageSize) => {
    const { dispatch } = this.props;
    dispatch({
      type: 'pushAnalyze/fetchList',
      params: {
        page,
        pageSize,
        groupid: GetQueryString('groupId'),
      },
    });
  };

  setColumns = () => {
    const columns = [
      {
        title: '学校名称',
        dataIndex: 'schoolName',
        key: 'schoolName',
      },
      {
        title: '所属教育局',
        dataIndex: 'bureauName',
        key: 'bureauName',
      },
      {
        title: '送达用户数',
        dataIndex: 'pushNum',
        key: 'pushNum',
      },
      {
        title: '状态',
        dataIndex: 'pushStatus',
        key: 'pushStatus',
        render: text => {
          return <Badge color={statusColor[text]} text={statusText[text]} />;
        },
      },
      {
        title: '发布时间',
        dataIndex: 'pushMsgLastTime',
        key: 'pushMsgLastTime',
        render: text => {
          return <span>{moment(text).format('YYYY-MM-DD HH:mm:ss')}</span>;
        },
      },
    ];
    this.setState({ columns });
  };

  onPageChange = (page, pageSize) => {
    this.fetchList(page, pageSize);
  };

  render() {
    const { columns } = this.state;
    const { spinProps, pageInfo, list } = this.props;
    const pageProps = {
      spinProps,
      className: styles.root,
    };
    const tableProps = {
      pageInfo,
      columns,
      list,
      rowKey: 'id',
      onPageChange: this.onPageChange,
    };

    return (
      <Container breStates={!0} version={2}>
        <ListPage {...pageProps}>
          <ListTable {...tableProps} />
        </ListPage>
      </Container>
    );
  }
}
export default PushAnalyze;
